import { services } from "../../../api";
import { Filter, FilterItem, Tab } from "../../../interfaces/api/congresses";
import { store } from "../../../redux/store";
import { TabId } from "../../../shared/utils/enums";
import { setLoadingTabs, setTabs } from "../../auth/login/reducer";

export const getTabs = async () => {
  try {
    store.dispatch(setLoadingTabs(true));
    const allTabs = (await services.tabs.getFilters()) as any;
    const tabs = allTabs.content?.data || [];
    store.dispatch(setTabs(tabs));
  } catch (ex) {
    store.dispatch(setLoadingTabs(false));
  }
};

/**
 * Retrieves the list of letter filter items for a given tab ID.
 * @param tabId - The ID of the tab to retrieve letters for.
 * @returns An array of FilterItem objects representing the letters filter, or an empty array if not found.
 */
export const getLetters = (tabId: TabId): FilterItem[] => {
  const tabs = store.getState().auth?.tabs;
  if (!tabs?.length) return [];

  const selectedTab = tabs.find((tab: Tab) => tab.id === tabId);
  if (!selectedTab?.filters?.length) return [];

  const lettersFilter = selectedTab.filters.find(
    (filter: Filter) => filter.filter_name === "letters",
  );
  return lettersFilter?.items ?? [];
};
